// extracted by mini-css-extract-plugin
export default {"requirement-card-button":"style_requirement-card-button__H1kSn","requirementCardButton":"style_requirement-card-button__H1kSn"};